import {
  AUTH_SIGNIN_REQUEST,
  AUTH_SIGNIN_SUCCESS,
  AUTH_SIGNIN_FAILURE,
  AUTH_SIGNUP_REQUEST,
  AUTH_SIGNUP_SUCCESS,
  AUTH_SIGNUP_FAILURE,
  AUTH_FORGOT_REQUEST,
  AUTH_FORGOT_SUCCESS,
  AUTH_FORGOT_FAILURE,
  AUTH_SET_PASSWORD_REQUEST,
  AUTH_SET_PASSWORD_SUCCESS,
  AUTH_SET_PASSWORD_FAILURE,
} from './AuthActions';

const initialState = {
  signup: null,
  signin: null,
  signinMeta: null,
  signupMeta: null,
  isLoading: false,
  signinError: false,
  signupError: false,
  forgot: null,
  forgotMeta: null,
  forgotError: false,
  setPassword: null,
  setPasswordMeta: null,
  setPasswordError: false,
};

export default function authReducer(
  state = initialState,
  { type, payload, meta },
) {
  switch (type) {
    case AUTH_SIGNIN_REQUEST:
      return { ...state, isLoading: true, signinError: null, signinMeta: null };
    case AUTH_SIGNIN_SUCCESS:
      if (payload.data.access_token) {
        localStorage.setItem('jwt_token', payload.data.access_token);
      }
      return {
        ...state,
        signin: payload.data,
        signinError: null,
        isLoading: false,
      };
    case AUTH_SIGNIN_FAILURE:
      return {
        ...state,
        signin: null,
        signinError: payload.message
          ? payload.message
          : 'Something went wrong.',
        signinMeta: meta,
        isLoading: false,
      };

    case AUTH_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        signup: null,
        signupError: null,
        signupMeta: null,
      };
    case AUTH_SIGNUP_SUCCESS:
      return {
        ...state,
        signup: payload.data,
        signupError: null,
        isLoading: false,
      };
    case AUTH_SIGNUP_FAILURE:
      return {
        ...state,
        signup: null,
        signupError: payload.response.error,
        signupMeta: meta,
        isLoading: false,
      };

    case AUTH_FORGOT_REQUEST:
      return {
        ...state,
        isLoading: true,
        forgot: null,
        forgotError: null,
        forgotMeta: null,
      };
    case AUTH_FORGOT_SUCCESS:
      return {
        ...state,
        forgot: payload.data,
        forgotError: null,
        isLoading: false,
      };
    case AUTH_FORGOT_FAILURE:
      return {
        ...state,
        forgot: null,
        forgotError: payload.response.error,
        forgotMeta: meta,
        isLoading: false,
      };

    case AUTH_SET_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        setPassword: null,
        setPasswordError: null,
        setPasswordMeta: null,
      };
    case AUTH_SET_PASSWORD_SUCCESS:
      return {
        ...state,
        setPassword: payload.data,
        setPasswordError: null,
        isLoading: false,
      };
    case AUTH_SET_PASSWORD_FAILURE:
      return {
        ...state,
        setPassword: null,
        setPasswordError: payload.response.error,
        setPasswordMeta: meta,
        isLoading: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/AuthReducer.js